import { EGroupedItemsType } from '~/src/services/properties';

interface IAnalytics {
    category: string,
    action: string,
    label: string,
}
export type TAnalytics = IAnalytics | Record<string, any>;

export const analytics = {
    name: 'analytics',
    order: 1,
    label: 'Аналитика:',
    items: {
        category: {
            name: 'category',
            label: 'Category',
            type: EGroupedItemsType.String,
        },
        action: {
            name: 'action',
            label: 'Action',
            type: EGroupedItemsType.String,
        },
        label: {
            name: 'label',
            label: 'Label',
            type: EGroupedItemsType.String,
            size: 'lg',
        },
    },
};
